export default __webpack_public_path__ + "static/media/icon-logo.0eedb736.svg";